import { useSelector } from 'react-redux';

import { AgenticReview } from './AgenticReview';
import { NonAgenticReview } from './NonAgenticReview';
import { selectDraftAutonomousActions, selectHasNbaConfig } from '../../redux/selectors';

/**
 * Step 3: Unified Review page
 * Delegates on whether the campaign is agentic (NBA), NOT on campaign type — any campaign
 * type (Outreach or Payment Recovery) can be agentic or non-agentic. This is why the two
 * implementations are named by agentic state, not by type (unlike the Audience/Logs
 * wrappers, which genuinely split on campaign type for type-specific fields).
 *
 * Agentic campaigns (autonomous actions ON or persisted nba_config) run over time and use
 * the review flow with start + end scheduling. Non-agentic campaigns are one-shot sends and
 * use the simpler start-only review flow. The shared ReviewSummary inside each reflects the
 * campaign type and agentic state.
 */
export const UnifiedReview = () => {
  const autonomousActions = useSelector(selectDraftAutonomousActions);
  const hasNbaConfig = useSelector(selectHasNbaConfig);

  if (hasNbaConfig || autonomousActions) {
    return <AgenticReview />;
  }

  return <NonAgenticReview />;
};
